import { useAppContext } from "@soft-db/ui";
import { useLocalStorage } from "@vueuse/core";
import { defineStore } from "pinia";
import { ref } from "vue";

export enum MapTabs {
	default = 0,
	client = 1,
}

export const useMapStore = defineStore("map-store", () => {
	const showStations = ref(true);
	const showSites = ref(true);
	const showClientProjects = ref(true);
	const tab = ref(0);

	const mapTypeId = useLocalStorage("mapTypeId", "roadmap");

	function toggleShowStations() {
		showStations.value = !showStations.value;
	}
	function toggleShowProjects() {
		showSites.value = !showSites.value;
	}

	const lightMapId = "b9e9a514cdd95e43";
	const darkMapId = "3946b010873fb8fb";

	const { dark } = useAppContext();
	const mapId = computed(() => (dark.value ? darkMapId : lightMapId));

	return {
		mapId,
		showStations,
		showSites,
		showClientProjects,
		tab,
		mapTypeId,
		toggleShowStations,
		toggleShowProjects,
	};
});
